"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _utils = require("@material-ui/utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["aria-label", "dataMetrics", "size"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultProps = {
  dataMetrics: {
    root: 'fuse_circular_progress'
  },
  disableShrink: false,
  size: 'medium',
  value: 0,
  variant: 'indeterminate'
};
var SIZE_MAP = Object.freeze({
  large: {
    size: 64,
    thickness: 5
  },
  medium: {
    size: 48,
    thickness: 4
  },
  small: {
    size: 24,
    thickness: 3
  }
});
var CircularProgress = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _ref$ariaLabel = _ref['aria-label'],
    ariaLabel = _ref$ariaLabel === void 0 ? 'circular-progress' : _ref$ariaLabel,
    dataMetrics = _ref.dataMetrics,
    size = _ref.size,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], (0, _extends2["default"])({
    "aria-label": ariaLabel,
    "data-metrics": mergedDataMetrics.root,
    ref: ref
  }, SIZE_MAP[size] || {
    size: size
  }, rest));
});
CircularProgress.defaultProps = defaultProps;
CircularProgress.displayName = 'CircularProgress';
CircularProgress.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * attribute used to define a string that labels the current element. Use for accessibility.
   */
  'aria-label': _propTypes["default"].string,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/circular-progress/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * If `true`, the shrink animation is disabled. This only works if variant is indeterminate.
   */
  disableShrink: _propTypes["default"].bool,
  /**
   * Size of the circle:
   * `small` (24x24),
   * `medium` (48x48),
   * `large` (64x64)
   * or custom size "40px" "25rem" "10em"
   */
  size: function size(props, propName, componentName) {
    var correctUnitRegex = /([0-9]*\.?[0-9]+)(em|px|rem)/;
    if (!/size/.test(props[propName]) && !SIZE_MAP[props.size] && typeof props.size !== 'number' && !correctUnitRegex.test(props[propName])) {
      return new Error(" `".concat(propName).concat(props.size, "` supplied to `").concat(componentName, "` is not a valid value.\n      Please check the documentation and try again with a default value ('small', 'medium', 'large' ) or a valid css size (ex: '40px', '40em')"));
    }
  },
  /**
   * Multiple styles can be passed in including custom colors
   * style: {{ color: "#CCC" }}
   */
  style: _propTypes["default"].object,
  /**
   * If using a custom pixel size you can pass in the thickness.
   */
  thickness: _propTypes["default"].number,
  /**
   * The value of the progress indicator for the determinate variant. Value between 0 and 100.
   */
  value: _propTypes["default"].number,
  /**
   * The variant to use. Use indeterminate when there is no progress value.
   */
  variant: (0, _utils.chainPropTypes)(_propTypes["default"].oneOf(['determinate', 'indeterminate', 'static']), function (props) {
    var variant = props.variant;
    if (variant === 'static') {
      throw new Error('Material-UI: `variant="static"` was deprecated. Use `variant="determinate"` instead.');
    }
    return null;
  })
} : {};
var _default = CircularProgress;
exports["default"] = _default;